import { render, staticRenderFns } from "./pointsMgn.vue?vue&type=template&id=48d141a8&scoped=true&"
import script from "./pointsMgn.vue?vue&type=script&lang=js&"
export * from "./pointsMgn.vue?vue&type=script&lang=js&"
import style0 from "./pointsMgn.vue?vue&type=style&index=0&id=48d141a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d141a8",
  null
  
)

export default component.exports